import { CustomEventDetailTrackViewData, TealiumData } from "../types";

// This event is not renamed from @argonaut/analytics/* to @rea-argonaut/analytics/* because it is dispatched in MFEs and listened for in app shell
export const CUSTOM_EVENT_TRACK_VIEW_DATA = "@argonaut/analytics/trackViewData";

export const trackViewData = (viewData: TealiumData): void => {
  if (typeof document === "object") {
    document.dispatchEvent(
      new CustomEvent<CustomEventDetailTrackViewData>(
        CUSTOM_EVENT_TRACK_VIEW_DATA,
        {
          detail: { viewData },
        },
      ),
    );
  }
};
